import React from 'react';
import { Box, Text, Toggle } from '@common-fe/common-fe';

interface Props {
  disabled?: boolean;
  testId?: string;
  value: boolean;
  onChangeValue: (value: boolean) => void;
}

const ToggleSSNVisible: React.FC<Props> = ({ testId = 'toggle-ssn', disabled, value, onChangeValue }) => {
  return (
    <div>
      <Box direction="row" align="center">
        <Text
          style={{ whiteSpace: 'nowrap' }}
          margin={{ right: 'spacing8' }}
          color={disabled ? 'textDisabled' : 'textBody'}
        >
          Show full SSN
        </Text>

        <div>
          <Toggle
            testId={testId}
            disabled={disabled}
            label="Show full SSN"
            value={value}
            onChange={onChangeValue}
          />
        </div>
      </Box>
    </div>
  );
};

export default ToggleSSNVisible;
